<template>
  <div class="shop-authentication-page">
    <h5 class="page-title">{{ storeType == 1 ? "个人认证" : "企业认证" }}</h5>
    <div style="height: 122px; width: 572px" v-loading="loading">
      <div
        v-if="authenticationStatus == 1"
        class="authentication-box"
        :style="storeType == 2 ? 'width: 506px;' : ''"
      >
        <div class="status-info">
          <img
            src="../../assets/images/shop-authentication/status1.png"
            alt="未认证"
            class="status"
          />
          <div class="info">
            <p class="info-title">未认证</p>
            <p class="info-text">认证后解锁更多功能</p>
          </div>
        </div>
        <div class="authentication-btn" @click="toAuthentication()">去认证</div>
      </div>
      <div
        v-else-if="authenticationStatus == 2 && storeType == 2"
        class="authentication-box status2"
      >
        <div class="status-info">
          <img
            src="../../assets/images/shop-authentication/status2.png"
            alt="审核中"
            class="status"
          />
          <div class="info">
            <p class="info-title">审核中</p>
            <p class="info-text">
              {{ authenticationInfo.corporateName || "未知" }}
            </p>
          </div>
        </div>
        <p class="text">耐心等待审核结果哦~</p>
      </div>
      <div
        v-else-if="authenticationStatus == 3"
        class="authentication-box status3"
        :style="storeType == 2 ? 'width: 506px' : ''"
      >
        <div class="status-info">
          <img
            src="../../assets/images/shop-authentication/status3.png"
            alt="已认证"
            class="status"
          />
          <div class="info" :style="storeType == 2 ? 'width: 280px' : ''">
            <p class="info-title">已认证</p>
            <p class="info-text">
              {{
                storeType == 1
                  ? authenticationInfo.realName || "未知"
                  : authenticationInfo.corporateName || "未知"
              }}
            </p>
          </div>
        </div>
        <p class="text">快去体验其他功能吧~</p>
      </div>
    </div>

    <!-- 是否完成个人认证弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      top="calc(50vh -  102px)"
      @close="closeDialog"
      width="400px"
    >
      <p class="dialog-text">是否完成个人认证</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">未完成</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >已完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "ShopCenterAdminWebShopAuthentication",

  data() {
    return {
      // storeType: 2, // 店铺类型 1-个人 2-企业
      authenticationStatus: 0, // 认证状态 1-未认证 2-审核中（企业专有） 3-已认证
      authenticationInfo: {}, // 已认证/审核中 的认证信息
      dialogVisible: false, // 是否展示个人认证弹窗
      loading: true, // loading状态
    };
  },
  computed: {
    storeType() {
      // 店铺类型 1-个人 2-企业
      if (
        this.$store.state.user.userInfo.organizationTypeId == 1 ||
        (this.$store.state.user.userInfo.organizationTypeId == 2 &&
          this.$store.state.user.userInfo.shopTypeId == 65)
      ) {
        return 1;
      }
      return 2;
    },
  },

  mounted() {
    if (this.storeType == 1) {
      this.getISPerson();
    } else {
      this.getIsEnterprise();
    }
  },

  methods: {
    // 获取个人认证信息
    async getISPerson() {
      this.loading = true;
      // 关闭弹窗
      this.dialogVisible = false;
      const res = await this.$axios.get(api.authentication.getIsPerson);
      // console.log("个人认证信息-----", res.result);
      this.authenticationInfo = res.result || {};
      // 如果两个字段都是false 则表示未认证
      if (!res.result || (!res.result.threeAuth && !res.result.fourAuth)) {
        this.authenticationStatus = 1;
      } else {
        this.authenticationStatus = 3;
      }
      this.loading = false;
    },
    // 获取企业认证信息
    async getIsEnterprise() {
      this.loading = true;
      let shopId = "";
      // 如果是运营人员
      if (this.$store.state.user.userInfo.userTypeId == 3) {
        shopId = this.$store.state.user.userInfo.shopId;
      }
      const res = await this.$axios.get(
        api.authentication.getIsEnterprise,
        {},
        {
          headers: {
            "shop-id": shopId,
          },
        }
      );
      // console.log("企业认证信息-----", res.result);
      this.authenticationInfo = res.result || {};
      // auditStatus  0-未认证，1-审核中，2-已认证
      if (res.result && res.result.auditStatus == 2) {
        this.authenticationStatus = 3;
      } else if (res.result && res.result.auditStatus == 1) {
        this.authenticationStatus = 2;
      } else {
        this.authenticationStatus = 1;
      }
      this.loading = false;
    },
    // 去认证
    toAuthentication() {
      // 区分个人和企业认证
      if (this.storeType == 1) {
        // 打开弹窗
        this.dialogVisible = true;
        // 新开页面
        if (process.env.NODE_ENV == "production") {
          // 正式环境认证地址
          window.open(
            "https://act.zxxk.com/#/account-safe/index/identityForm",
            "_blank"
          );
        } else {
          // 测试环境认证地址
          window.open(
            "https://taccount.xkw.com/#/account-safe/index/identityAuth",
            "_blank"
          );
        }
      } else {
        this.$router.push("/authentication/enterprise-apply");
      }
    },
    // 关闭弹窗时刷新页面
    closeDialog() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-authentication-page {
  height: calc(100% - 50px);
  padding: 47px 0 0 60px;
  border-radius: 5px;
  background: #fff;
  .page-title {
    margin-bottom: 30px;
    color: #3a3d4b;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
  }
  .authentication-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 396px;
    height: 120px;
    padding: 0 32px;
    border-radius: 10px;
    border: 1px solid #dddfe6;
    background: #fefefe;
    .status-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .status {
        width: 74px;
        height: 74px;
        margin-right: 20px;
      }
      .info {
        max-width: 200px;
        .info-title {
          margin-bottom: 15px;
          color: #3a3d4b;
          font-size: 14px;
          font-weight: 600;
          line-height: 1; /* 100% */
        }
        .info-text {
          color: #606266;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
        }
      }
    }

    .authentication-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 76px;
      height: 32px;
      border-radius: 3px;
      background: #5a83ff;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      line-height: 1; /* 100% */
      cursor: pointer;
    }
    .text {
      color: #606266;
      font-size: 12px;
      line-height: 1; /* 100% */
    }
  }
  .status2 {
    width: 506px;
    border-radius: 10px;
    border: 1px solid #ffedb4;
    background: rgba(255, 194, 86, 0.05);
    .status-info {
      .info {
        max-width: 280px;
        .info-title {
          color: #f58800;
        }
      }
    }
  }
  .status3 {
    border-radius: 10px;
    border: 1px solid #e8edff;
    background: rgba(99, 132, 247, 0.05);
    .status-info {
      .info {
        .info-title {
          color: #5a83ff;
        }
      }
    }
  }
  .dialog-text {
    text-align: center;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
